import classNames from "classnames";

import classes from "./Footer.module.scss";
import { footerLinks } from "./footerLinks";

export const FooterSection = () => {
  return (
    <>
      <div className={classNames("row my-3 d-flex justify-content-center")}>
        <ul className={classNames("nav", classes.footerNavList)}>
          {footerLinks.map((link) => (
            <li key={link.id} className="nav-item">
              <a className="nav-link" href={link.link}>
                {link.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
